'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var V1_URL = 'https://js.paymentbrands.com/v1';
var V1_URL_REGEX = /^https:\/\/js\.paymentbrands\.com\/v1\/?(\?.*)?$/;
var V1_URL_DEV = 'https://js-dev1.paymentbrands.com/v1';
var V1_URL_DEV_REGEX = /^https:\/\/js-dev1\.paymentbrands\.com\/v1\/?(\?.*)?$/;
var V1_URL_INT = 'https://js-int.paymentbrands.com/v1';
var V1_URL_INT_REGEX = /^https:\/\/js-int\.paymentbrands\.com\/v1\/?(\?.*)?$/;
var V1_URL_BETA = 'https://js-beta.paymentbrands.com/v1';
var V1_URL_BETA_REGEX = /^https:\/\/js-beta\.paymentbrands\.com\/v1\/?(\?.*)?$/;
var V1_URL_STAGING = 'https://js-stg.paymentbrands.com/v1';
var V1_URL_STAGING_REGEX = /^https:\/\/js-stg\.paymentbrands\.com\/v1\/?(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = 'loadScript was called but an existing Payments.js script already exists in the document.';
var findScript = function findScript(mode) {
  var scripts = document.querySelectorAll("script[src^=\"".concat(scriptUrl(mode), "\"]"));
  for (var i = 0; i < scripts.length; i++) {
    var script = scripts[i];
    if (!scriptRegex(mode).test(script.src)) {
      continue;
    }
    return script;
  }
  return null;
};
var scriptUrl = function scriptUrl(mode) {
  switch (mode) {
    case 'dev':
      return V1_URL_DEV;
    case 'int':
      return V1_URL_INT;
    case 'beta':
      return V1_URL_BETA;
    case 'stg':
      return V1_URL_STAGING;
    case 'prd':
      return V1_URL;
    default:
      return V1_URL;
  }
};
var scriptRegex = function scriptRegex(mode) {
  switch (mode) {
    case 'dev':
      return V1_URL_DEV_REGEX;
    case 'int':
      return V1_URL_INT_REGEX;
    case 'beta':
      return V1_URL_BETA_REGEX;
    case 'stg':
      return V1_URL_STAGING_REGEX;
    case 'prd':
      return V1_URL_REGEX;
    default:
      return V1_URL_REGEX;
  }
};
var injectScript = function injectScript(mode) {
  var script = document.createElement('script');
  script.src = "".concat(scriptUrl(mode));
  var headOrBody = document.head || document.body;
  if (!headOrBody) {
    throw new Error('Expected document.body not to be null. Payments.js requires a <body> element.');
  }
  headOrBody.appendChild(script);
  return script;
};
var paymentsPromise = null;
var loadScript = function loadScript() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'prd';
  // Ensure that we only attempt to load Payments.js at most once
  if (paymentsPromise !== null) {
    return paymentsPromise;
  }
  paymentsPromise = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      // Resolve to null when imported server side. This makes the module
      // safe to import in an isomorphic code base.
      resolve(null);
      return;
    }
    if (window.Payments) {
      console.warn(EXISTING_SCRIPT_MESSAGE);
    }
    if (window.Payments) {
      resolve(window.Payments);
      return;
    }
    try {
      var script = findScript(mode);
      if (script) {
        console.warn(EXISTING_SCRIPT_MESSAGE);
      } else if (!script) {
        script = injectScript(mode);
      }
      script.addEventListener('load', function () {
        if (window.Payments) {
          resolve(window.Payments);
        } else {
          reject(new Error('Payments.js not available'));
        }
      });
      script.addEventListener('error', function () {
        reject(new Error('Failed to load Payments.js'));
      });
    } catch (error) {
      reject(error);
      return;
    }
  });
  return paymentsPromise;
};
var initPayments = function initPayments(maybePayments, args) {
  if (maybePayments === null) {
    return null;
  }
  var _args = _slicedToArray(args, 1),
    publishableKey = _args[0];
  var payments = maybePayments(publishableKey);
  return payments;
};

var loadPayments = function loadPayments() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'prd';
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return loadScript(mode).then(function (maybePayments) {
    return initPayments(maybePayments, args);
  });
};

exports.loadPayments = loadPayments;
